export default new class popupAllegrocount {
  constructor() {
    this.popupContainer = '_popup-allegrocount';
    this.popupContainerClose = '_popup-allegrocount-close';
    this.timeShowAuto = 1000;
    this.init();
  }

  init() {
    $(window).on('load', () => {
      $(`.${this.popupContainer}`).delay(800).fadeIn('slow');
      setTimeout(() => {
        $.request('onAjax', {
          update: {
            'content/popup/popup-allegrocount': `.${this.popupContainer}`,
          },
          success(result) {
            this.success(result);
          },
        });
      }, this.timeShowAuto);
    });

    $(document).on('click', `.${this.popupContainerClose}`, () => {
      $(`.${this.popupContainer}`).delay(200).fadeOut('slow');
    });
  }
}();
